<!-- Loading Screen -->

@if (isReportSending) {
  <div class="wrapper center"
    >
    <div class="inner">
      <mat-spinner> </mat-spinner>
    </div>
  </div>
}

<!-- End Fishing Report-->

@if (!isReportSending) {
  <div class="container report-container"
    >
    <div class="container"
      style="padding-top: 20px;">
      <div class="row"
        align="center">
        @if (currPage <= numPages) {
          <h6 i18n>
        <small class="text-muted">
          Page {{currPage}} of {{numPages}}
        </small>
      </h6>
        }
        @if (currPage > numPages) {
          <h6 i18n>
        <small class="text-muted">
          End Fishing Report
        </small>
      </h6>
        }
      </div>
      <div class="row"
        align="center">
        <div class="col-5"></div>
        <div class="col-2">
          @if (currPage <= numPages) {
            <mat-spinner
              mode="determinate"
              [diameter]="50"
              [strokeWidth]="6"
            [value]="spinnerProgress"></mat-spinner>
          }
          @if (currPage > numPages && !isComplete) {
            <mat-icon
              class="top-icon">
              check_circle_outline
            </mat-icon>
          }
        </div>
        <div class="col-5"></div>
      </div>
    </div>
    <!-- Page 1: When did you stop fishing? -->
    @if (currPage === 1) {
      <div>
        <div class="row" align="center">
          <h5 i18n class="blue-heading-title">When did you stop fishing?</h5>
        </div>
        <div class="row" align="center">
          <div class="col-2"></div>
          <div class="col-8">
            <mat-card class="demo-inline-calendar-card calendar-width" style="margin-top: 10%">
              <mat-calendar [(selected)]="endDate" [minDate]="minEndDate" (selectedChange)="onEndDateChange($event)"></mat-calendar>
            </mat-card>
          </div>
          <div class="col-2"></div>
        </div>
        <div class="outer">
          <div class="inner-2">
            <h6 i18n class="blue-label">Time (24hr): &nbsp;</h6>
          </div>
          <div class="inner-2">
            <ngb-timepicker class="time-picker"
              [spinners]="false"
              (ngModelChange)="onEndTimeChange($event)"
              [ngModelOptions]="{ standalone: true }"
              [(ngModel)]="endTime">
            </ngb-timepicker>
          </div>
        </div>
        <!-- Last Management Area (auto-filled from the last catch/pause report, editable) -->
        <div class="row" align="center">
          <h5 i18n class="blue-heading-title">What was the last management area fished?</h5>
        </div>
        <div class="row">
          <h6 i18n class="blue-label">Management Area</h6>
          <mat-form-field appearance="outline">
            <mat-label i18n>Management Area</mat-label>
            <mat-select [ngModel]="endManagementArea"
              (ngModelChange)="onManagementAreaChange($event)"
              [ngModelOptions]="{ standalone: true }"
              [compareWith]="compareArea">
              @for (area of managementAreas; track area) {
                <mat-option [value]="area">
                  {{ area }}
                </mat-option>
              }
            </mat-select>
          </mat-form-field>
          @if (!isAreaValid()) {
            <h5 i18n class="header-required">
              Required - Select the last management area fished
            </h5>
          }
        </div>
        <!-- Last subarea fished (only shown when the chosen management area has subareas) -->
        @if (subAreas.length) {
          <div class="row">
            <h6 i18n class="blue-label">Subarea</h6>
            <mat-form-field appearance="outline">
              <mat-label i18n>Subarea</mat-label>
              <mat-select [(ngModel)]="endSubArea"
                [ngModelOptions]="{ standalone: true }"
                [compareWith]="compareArea">
                @for (subArea of subAreas; track subArea) {
                  <mat-option [value]="subArea">
                    {{ subArea }}
                  </mat-option>
                }
              </mat-select>
            </mat-form-field>
          </div>
        }
      </div>
    }
    <form [formGroup]="arrivalForm">
      <!-- Page 2: Arrival Form -->
      @if (currPage === 2 && needsArrivalForm) {
        <div>
          <!-- Planned Offload Date & Time -->
          <div class="row" align="center">
            <h5 i18n class="blue-heading-title">When do you plan to offload?</h5>
          </div>
          <div class="row" align="center">
            <div class="col-2"></div>
            <div class="col-8">
              <mat-card class="demo-inline-calendar-card calendar-width" style="margin-top: 10%">
                <mat-calendar [(selected)]="plannedOffloadDate"
                  [minDate]="sharedMethodsService.getMinDate(currTrip)"
                  (selectedChange)="onPlannedOffloadDateChange($event)">
                </mat-calendar>
              </mat-card>
            </div>
            <div class="col-2"></div>
          </div>
          <div class="outer">
            <div class="inner-2">
              <h6 i18n class="blue-label">Time (24hr): &nbsp;</h6>
            </div>
            <div class="inner-2">
              <ngb-timepicker class="time-picker"
                [spinners]="false"
                [ngModelOptions]="{ standalone: true }"
                [(ngModel)]="plannedOffloadTime"
                (ngModelChange)="onPlannedOffloadTimeChange($event)">
              </ngb-timepicker>
            </div>
            @if (arrivalForm.hasError('offloadTooEarly')) {
              <div class="invalid-field">
                Planned offload must be after the end of fishing.
              </div>
            }
          </div>
          <!-- Landing Site -->
          <div class="row" align="center">
            <h5 i18n class="blue-heading-title">Where will you land?</h5>
          </div>
          <div class="row">
            <h6 i18n class="blue-label">Designated Landing Site</h6>
            <mat-form-field appearance="outline">
              <mat-label i18n>Site Name</mat-label>
              <mat-select formControlName="site" [compareWith]="compareSite">
                @for (site of relevantLandingSites; track site) {
                  <mat-option i18n
                    [value]="site">
              @if (site.name == 'Not Listed' || site.name == 'Not Offloading / No Catch') {
<div>
                {{ site.name }}
              </div>
}
              @if (site.name != 'Not Listed' && site.name != 'Not Offloading / No Catch') {
<div>
                {{ site }}
              </div>
}
            </mat-option>
                }
              </mat-select>
              @if (arrivalForm.invalid) {
                <mat-error i18n>
            Required
          </mat-error>
              }
            </mat-form-field>
            @if (nonListedSite) {
              <h5 class="header-required">
                Required - Enter your landing site in the comments field
              </h5>
            }
          </div>
        </div>
      }
    </form>
    <!-- Page 3: Comments -->
    @if (((currPage === 3 && needsArrivalForm) || (currPage === 2 && !needsArrivalForm))) {
      <div>
        <form [formGroup]="endForm">
          <div class="row" align="center">
            <h5 i18n class="blue-heading-title">Would you like to add a comment?</h5>
          </div>
          <div class="row">
            <h6 i18n class="blue-label">Comments</h6>
            <mat-form-field appearance="fill">
              <mat-label i18n>Comments...</mat-label>
              <textarea matInput
                maxlength="300"
                rows="9"
                formControlName="comments">
              </textarea>
              @if (endForm.invalid) {
                <mat-error i18n>
            Required @if (nonListedSite) {-- Landing site required}
          </mat-error>
              }
            </mat-form-field>
          </div>
        </form>
      </div>
    }
    <!-- Summary page -->
    @if (currPage > numPages) {
      <div
        class="container details">
        @if (!isComplete && !isEditing) {
          <div class="row"
            align="center">
            <h5 i18n class="blue-heading-title">
        Is all Hail In information complete and ready to be submitted to DFO?
      </h5>
          </div>
        }
        @if (isEditing) {
          <div class="row"
            align="center">
            <h5 i18n class="blue-heading-title">
        Are these edits correct and ready to be submitted to Archipelago?
      </h5>
          </div>
        }
        @if (isComplete) {
          <div class="row">
            <h6 class="blue-label">
              <b i18n>
          Confirmation Number:
        </b>
              @if (endFishingReport.confirmationNumber === 'Incomplete' ||
                endFishingReport.confirmationNumber === 'Not submitted' ||
                endFishingReport.confirmationNumber === 'Awaiting response') {
                <span i18n>
          {endFishingReport.confirmationNumber, select, Incomplete {Incomplete} Not submitted {Not submitted} Awaiting response {Awaiting response}}
        </span>
              } @else {
                {{endFishingReport.confirmationNumber}}
              }
            </h6>
          </div>
        }
        @if (this.endFishingReport.confirmationNumber == 'Not submitted') {
          <div>
            <span i18n class="blue-label">
        Go to the records page to submit outstanding reports
      </span>
          </div>
        }
        @if (reportFailed) {
          <div class="row">
            <button mat-raised-button
              class="fishing-button-red"
              type="submit"
              (click)="reopenReport()"
              style="width: auto; text-align: left;">
              <span i18n>
          Reopen report
        </span>
            </button>
          </div>
        }
        <div>
          <div class="row">
            <h6 i18n class="blue-label">
          <b>
            End Date:
          </b>
          {{ endDate | date }}
        </h6>
          </div>
          <div class="row">
            <h6 i18n class="blue-label">
          <b>
            End Time:
          </b>
          <span>
            {{ getArrivalTime(endTime) | date: 'shortTime' }}
          </span>
          @if (!endTime) {
<span
                class="invalid-field">
            [Required]
          </span>
}
        </h6>
          </div>
          <div class="row">
            <h6 i18n class="blue-label">
          <b>
            Last Management Area:
          </b>
          <span>
            {{ endManagementArea.name ? endManagementArea : '' }}
          </span>
          @if (!isAreaValid()) {
<span
                class="invalid-field">
            [Required]
          </span>
}
        </h6>
          </div>
          @if (endSubArea.name) {
            <div class="row">
              <h6 i18n class="blue-label">
          <b>
            Last Subarea:
          </b>
          <span>
            {{ endSubArea }}
          </span>
        </h6>
            </div>
          }
          @if (needsArrivalForm) {
            <div class="row">
              <h6 i18n class="blue-label">
          <b>
            Planned Offload Date:
          </b>
          {{ plannedOffloadDate | date }}
        </h6>
            </div>
          }
          @if (needsArrivalForm) {
            <div class="row">
              <h6 i18n class="blue-label">
          <b>
            Planned Offload Time:
          </b>
          <span>
            {{ getArrivalTime(plannedOffloadTime) | date: 'shortTime' }}
          </span>
          @if (!plannedOffloadTime) {
<span
                class="invalid-field">
            [Required]
          </span>
}
          @if (arrivalForm.hasError('offloadTooEarly')) {
<span class="invalid-field">
          Planned offload must be after the end of fishing.
        </span>
}
        </h6>
            </div>
          }
          @if (needsArrivalForm) {
            <div class="row">
              <h6 i18n class="blue-label">
          <b>
            Landing Site:
          </b>
          {{ arrivalForm.get('site')?.value }}
          @if (arrivalForm.get('site')?.errors?.required) {
<span
                class="invalid-field">
            [Required]
          </span>
}
        </h6>
            </div>
          }
        </div>
        <div class="row">
          <h6 i18n class="blue-label">
        <b>
          Comments:
        </b>
        {{ endForm.get('comments')?.value }}
        @if (endForm.invalid) {
<span
              class="invalid-field">
          [Required] @if (nonListedSite) { -- Ensure your landing site has been entered}
        </span>
}
      </h6>
        </div>
      </div>
    }
    <!-- Buttons to navigate between pages -->
    @if (!isComplete) {
      <div class="row bottom-buttons">
        <div class="col-1"></div>
        <div class="col-4">
          <div class="row"
            style="margin-top: 20px;">
            <button mat-raised-button
              class="fishing-button-blue"
              type="button"
              (click)="toPreviousPage()">
              <span i18n>
            Back
          </span>
            </button>
          </div>
        </div>
        <div class="col-2"></div>
        <div class="col-4">
          <div class="row"
            style="margin-top: 20px;">
            <button mat-raised-button
              class="fishing-button-red"
              type="submit"
              (click)="toNextPage()">
              @if (currPage <= numPages) {
                <span i18n>
            Next
          </span>
              }
              @if (currPage > numPages) {
                <span i18n>
            Submit
          </span>
              }
            </button>
          </div>
        </div>
        <div class="col-1"></div>
      </div>
    }
    @if (isComplete) {
      <div class="row bottom-buttons" style="display: flex; justify-content: center;">
        <div class="col-4">
          <div class="row" style="display: flex; justify-content: center;">
            <button mat-raised-button
              class="fishing-button-blue"
              type="button"
              (click)="toPreviousPage()">
              <span i18n>
            Back
          </span>
            </button>
          </div>
        </div>
      </div>
    }
  </div>
}
